// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientInfo_root__1cE_X","info":"PatientInfo_info__IfGti"};